import React from 'react'
import { Button } from '@shared/components/button'
import { Container } from '@shared/components/container'
import SadFace from '@shared/svg/sad-face.svg'
import Link from 'next/link'

import styles from './style.module.scss'

type AppErrorProps = {
	statusCode?: number
	onReload?: () => void
}

const reloadPage = () => {
	window.location.reload()
}

export const AppError = ({ statusCode: _statusCode, onReload = reloadPage }: AppErrorProps) => {
	return (
		<Container className={styles.wrapper}>
			<div className={styles.content}>
				<SadFace className={styles.icon} />
				<h1 className={styles.title}>Произошла ошибка</h1>
				<p className={styles.subtitle}>Попробуйте обновить страницу</p>
				<div className={styles.actions}>
					<Button
						className={styles.reloadButton}
						size='m'
						type='button'
						onClick={onReload}
					>
						Обновить страницу
					</Button>
					<Link className={styles.goHome} href='/'>
						На главную
					</Link>
				</div>
			</div>
		</Container>
	)
}
